import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, SFNavigationOptions } from '../utils/types';
import css from './Navigation.css';
import UserContainer from './UserContainer';
import MenuOptionsContainer from './MenuOptionsContainer';
import { hot } from 'react-hot-loader';

class Navigation extends React.Component {

  get utilitaryOptions() {
    return this.props.navigationOptions.filter(option => option.type === "utilitary");
  }

  get mainOptions() {
    return this.props.navigationOptions.filter(option => option.type === "main");
  }

  get studentOptions() {
    return this.props.navigationOptions.filter(option => option.type === "student");
  }

  render() {
    return (
      <nav className={css['navigation']}>
        <UserContainer
          isMobile={this.props.isMobile}
          id={this.props.userId}
          name={this.props.username}
          photoURL={this.props.photoURL}
          onNavigationDismissed={this.props.onNavigationDismissed}
          utilitaryOptions={this.utilitaryOptions}
          currentSection={this.props.currentSection}
          headerColor={this.props.headerColor}
        />
        <MenuOptionsContainer
          mainOptions={this.mainOptions}
          studentOptions={this.studentOptions}
          updateSection={this.props.updateSection}
          currentSection={this.props.currentSection}
        />
      </nav>
    );
  }
}

Navigation.propTypes = {
  isMobile: PropTypes.bool,
  userId: SFEntityID.isRequired,
  username: PropTypes.string.isRequired,
  photoURL: PropTypes.string.isRequired,
  navigationOptions: SFNavigationOptions.isRequired,
  onNavigationDismissed: PropTypes.func,
  updateSection: PropTypes.func.isRequired,
  currentSection: PropTypes.string,
  headerColor: PropTypes.string
};

export default hot(module)(Navigation);
